export default __webpack_public_path__ + "static/media/remove.b83180e3.svg";